import React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import Helmet from 'react-helmet';
import favicon from '../../images/favicon.ico';
import metaImage from '../../images/budget-capital-cover.png';

// site name used in social media metadata
const site = 'Budget.Mass.gov';
// organizations that are used for the org filter in Mass.gov search
const orgs = 'executiveofficeforadministrationandfinance,officeofgovernorcharliebakerandltgovernorkarynpolito';

const HelmetData = ({
  metaTitle,
  metaDescription,
  metaType,
  // eslint-disable-next-line camelcase
  mg_mod_date, mg_mod_datetime
}) => (
  <StaticQuery
    query={graphql`
      query HelmetQuery {
        site {
          siteMetadata {
            title
            siteUrl
          }
        }
        content: pagesJson(fields: {slug: {eq: "/"}}) {
          header {
            date
          }
        }
      }
    `}
    render={(data) => {
      const siteTitle = data.site.siteMetadata.title;
      // Initial release date used for sorting and date filters in Google search and Mass.gov search
      // Getting the date from data/pages/index.json
      // YYYYMMDD
      const { date } = data.content.header;
      const title = `${metaTitle} | ${siteTitle}`;

      const helmetData = {
        title,
        meta: [
          { name: 'description', content: metaDescription },
          // Global Mass.gov search engine metadata
          {
            name: 'mg_organization',
            content: orgs
          },
          {
            name: 'mg_date',
            content: date
          },
          {
            name: 'category',
            // Only tag homepage as data to show up in search.mass.gov data tab
            content: metaTitle === 'Home' ? 'data' : null
          },
          {
            name: 'mg_type',
            content: metaType
          },
          {
            name: 'mg_mod_date',
            content: mg_mod_date
          },
          {
            name: 'mg_mod_datetime',
            content: mg_mod_datetime
          },
          // Facebook open-graph metadata
          { property: 'og:title', content: title },
          { property: 'og:type', content: 'website' },
          { property: 'og:image', content: metaImage },
          { property: 'og:site_name', content: site },
          // Twitter card metadata
          { name: 'twitter:title', content: title },
          { name: 'twitter:description', content: metaDescription },
          { name: 'twitter:image', content: metaImage },
          { name: 'twitter:site"', content: site }
        ],
        link: [
          // favicon
          { rel: 'shortcut icon', type: 'image/ico', href: `${favicon}` }
        ]
      };

      return(
        <Helmet {...helmetData} />
      );
    }}
  />
);

HelmetData.propTypes = {
  metaTitle: PropTypes.string,
  metaDescription: PropTypes.string,
  metaType: PropTypes.string,
  mg_mod_date: PropTypes.string,
  mg_mod_datetime: PropTypes.string
};

export default HelmetData;
